import React, { useState, createContext, useEffect } from 'react';

export const LoadingContext = createContext(null);

export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!isLoading) {
      $('.loader').remove(); //this is a hack to hide laravel rendered loader.
    }
  }, [isLoading]);

  return (
    <LoadingContext.Provider value={setIsLoading}>
      {isLoading && (
        <div className="loader">
          <div className="loader__text">Loading...</div>
        </div>
      )}
      {children}
    </LoadingContext.Provider>
  );
};
